import React, { useCallback } from "react";

import { TextField } from "@mui/material";

let env = require("./../../../../env");

/***
 * translationValue = numberOfBagsInfo
 * language = "En"
 */
const TranslationTextField = React.memo(
  ({
    translationValue,
    language,
    value,
    replacementString,
    onTranslationUpdate
  }) => {
    const handleChange = useCallback(
      event => {
        onTranslationUpdate(translationValue, language, event.target.value);
      },
      [translationValue, language, onTranslationUpdate]
    );

    return (
      <>
        <TextField
          id={"txt" + translationValue + language}
          value={value || ""}
          onChange={handleChange}
          variant="outlined"
          fullWidth
          sx={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: "white"
            }
          }}
        />
        {replacementString ? (
          <div
            style={{
              width: "100%",
              textAlign: "left",
              color: "grey",
              fontStyle: "italic"
            }}
          >
            Replacement Strings: {replacementString}
          </div>
        ) : (
          <></>
        )}
      </>
    );
  }
);

export default TranslationTextField;
